{
  "name": "experian-serasajud-front-br",
  "version": "2.1.18",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start:dev": "ng serve -c dev",
    "start:uat": "ng serve -c qa",
    "build": "ng build",
    "test": "ng test --code-coverage",
    "postbuild": "node ./pre-build.js",
    "test:deploy": "ng test --code-coverage --no-watch --no-progress --browsers=ChromeHeadless",
    "lint": "ng lint",
    "e2e": "ng e2e"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.3.18",
    "@angular/cdk": "^20.2.14",
    "@angular/common": "^20.3.18",
    "@angular/compiler": "^20.3.18",
    "@angular/core": "^20.3.18",
    "@angular/forms": "^20.3.18",
    "@angular/localize": "^20.3.18",
    "@angular/material": "^20.2.14",
    "@angular/platform-browser": "^20.3.18",
    "@angular/platform-browser-dynamic": "^20.3.18",
    "@angular/router": "^20.3.18",
    "@datadog/browser-rum": "^6.16.0",
    "@ngx-translate/core": "^15.0.0",
    "@ngx-translate/http-loader": "^8.0.0",
    "ansi-regex": "^6.0.1",
    "bootstrap": "^4.1.3",
    "core-js": "^2.5.4",
    "glob-parent": "^6.0.1",
    "hammerjs": "^2.0.8",
    "json5": "^2.2.3",
    "moment": "^2.30.1",
    "ngx-mask": "^16.4.2",
    "rxjs": "~7.5.0",
    "simple-mask-money": "^2.0.1",
    "tslib": "^2.0.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^20.3.20",
    "@angular-eslint/builder": "16.3.1",
    "@angular-eslint/eslint-plugin": "16.3.1",
    "@angular-eslint/eslint-plugin-template": "16.3.1",
    "@angular-eslint/schematics": "^20.1.1",
    "@angular-eslint/template-parser": "16.3.1",
    "@angular/cli": "^20.3.20",
    "@angular/compiler-cli": "^20.3.18",
    "@angular/language-service": "^20.3.18",
    "@types/jasmine": "~3.6.0",
    "@types/jasminewd2": "~2.0.3",
    "@types/node": "^12.11.1",
    "@typescript-eslint/eslint-plugin": "5.62.0",
    "@typescript-eslint/parser": "5.62.0",
    "eslint": "^8.51.0",
    "jasmine-core": "^5.1.0",
    "jasmine-spec-reporter": "^7.0.0",
    "karma": "^6.4.2",
    "karma-chrome-launcher": "^3.2.0",
    "karma-coverage": "^2.2.1",
    "karma-coverage-istanbul-reporter": "^3.0.3",
    "karma-jasmine": "^5.1.0",
    "karma-jasmine-html-reporter": "^2.1.0",
    "protractor": "~7.0.0",
    "ts-node": "~7.0.0",
    "tslint": "~6.1.0",
    "typescript": "~5.8.3"
  }
}
